<template>
	<div>
		<fieldset>
			<h1><translate>Claim Analytics Unavailable</translate></h1>
			<p><translate>Unfortunately, the selected claim has no background data associated to it.</translate></p>
		</fieldset>
	</div>
</template>

<script>
export default {
	name: 'UnavailableClaim',
};
</script>
